export default {
  realProperty: 'Real property',
  movableProperty: 'Movable property',
}